var _desc, _defs, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _text, _g, _g2, _g3, _rect5, _rect6, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExamSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 540",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "School exam web system dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A web dashboard for exams with timer, question cards, results, and progress panels.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#052e2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c1d1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34d399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb7185"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 540,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 66,
    width: 788,
    height: 408,
    rx: 30,
    fill: "#020617",
    fillOpacity: 0.72,
    stroke: "#ffffff",
    strokeOpacity: 0.14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 66,
    width: 788,
    height: 56,
    rx: 30,
    fill: "#0f172a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 94,
    r: 7,
    fill: "#fb7185"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 94,
    r: 7,
    fill: "#fbbf24"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 94,
    r: 7,
    fill: "#34d399"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 84,
    width: 238,
    height: 20,
    rx: 10,
    fill: "#1e293b"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 159,
    fill: "#e2e8f0",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 800
  }, "Exam Panel")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 188)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 42,
    rx: 14,
    fill: "#34d399",
    fillOpacity: 0.16,
    stroke: "#34d399",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 27,
    fill: "#bbf7d0",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Dashboard"), /*#__PURE__*/React.createElement("rect", {
    y: 58,
    width: 132,
    height: 14,
    rx: 7,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 88,
    width: 108,
    height: 14,
    rx: 7,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 118,
    width: 145,
    height: 14,
    rx: 7,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 148,
    width: 96,
    height: 14,
    rx: 7,
    fill: "#334155"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 226,
    rx: 22,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 44,
    fill: "#0f172a",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 900
  }, "Question 12"), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 75,
    fill: "#475569",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15
  }, "Choose the correct REST API method."), /*#__PURE__*/React.createElement("g", {
    fill: "#e2e8f0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 101,
    width: 260,
    height: 34,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 147,
    width: 260,
    height: 34,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 193,
    width: 260,
    height: 34,
    rx: 12
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 147,
    width: 260,
    height: 34,
    rx: 12,
    fill: "#34d399",
    fillOpacity: 0.28,
    stroke: "#10b981",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 118,
    r: 7,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 164,
    r: 7,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 210,
    r: 7,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 123,
    fill: "#334155",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "GET"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 169,
    fill: "#047857",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "POST"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 215,
    fill: "#334155",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "VIEW"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(676 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 92,
    rx: 22,
    fill: "#0f172a",
    stroke: "#ffffff",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 35,
    fill: "#fecdd3",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "Timer"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 68,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 900
  }, "18:42"), /*#__PURE__*/React.createElement("rect", {
    y: 112,
    width: 156,
    height: 156,
    rx: 22,
    fill: "#0f172a",
    stroke: "#ffffff",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 147,
    fill: "#bfdbfe",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "Results"), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 176,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 176,
    width: 82,
    height: 12,
    rx: 6,
    fill: "url(#accent)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 209,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 209,
    width: 56,
    height: 12,
    rx: 6,
    fill: "#60a5fa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 242,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 242,
    width: 94,
    height: 12,
    rx: 6,
    fill: "#fbbf24"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 414,
    width: 512,
    height: 28,
    rx: 14,
    fill: "#1e293b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 414,
    width: 378,
    height: 28,
    rx: 14,
    fill: "url(#accent)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 433,
    fill: "#022c22",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 900
  }, "74% completed")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamSystem);
export default __webpack_public_path__ + "static/media/exam-system.ec20ccfcea860d3d7501234b7ead4a81.svg";
export { ForwardRef as ReactComponent };